export const NOT_FOUND_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240509-e4f4b-92c32';

export const BROWSING_HISTORY_COOKIE = 'browsingHistory';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

export const NO_EQUIPMENT_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250107-dc586-98c49',
  alt: 'No Equipment'
};
export const NO_SERVICE_INSIGHTS_IMG =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20241115-93833-7095b';

export const NEW_STATE = 'new';

export const PRODUCT_LIST_LIMIT = 2;

export const SOFTWARE_PART_TYPE = 'Software';
export const RECENTLY_VIEWED = 'recentlyViewed';
